import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const select = async (data: any) => {
  return httpRequest.get("/inv/branch/select", data);
};
